import(/* webpackMode: "eager" */ "/workspace/app/trending-now/components/Products.jsx")